import { useState,useEffect } from "react";
import { setToLS,getFromLS } from "../utils/storage";

import _ from 'lodash';

export const useTheme = () => {
    // Getting all themes from local storage  
    const themes = getFromLS('all-theme');
    const [theme, setTheme] = useState(themes.data.default);
    const [themeLoaded, setThemeLoaded] = useState(false);

    const setMode = mode => {
        setToLS('theme', mode)
        setTheme(mode);
    };
    // getting fonts from lodash package mentioned in themes array.
    
    const getFonts = () => {
        const allFonts = _.values(_.mapValues(themes.data, 'font'));
        return allFonts;
    }
    // if no theme is found set default theme=light.
    useEffect(() =>{
        const localTheme = getFromLS('theme');
        localTheme ? setTheme(localTheme) : setTheme(themes.data.seaWave);
        setThemeLoaded(true);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    

  return { theme, themeLoaded, setMode, getFonts };
};
